import { createFileRoute } from "@tanstack/react-router"

import { query } from "@/api/query"
import { routeGuard } from "@/lib/routing/beforeLoad"

export const Route = createFileRoute("/_authlayout/_sidebar/settings/")({
  beforeLoad: async ({ context }) => {
    await routeGuard(context, { allowPrivateSpace: false })
  },
  loader: ({ context: { queryClient, spaceStorage } }) => {
    const space = spaceStorage.getSpace()

    queryClient.query({ ...query.space.members(space), staleTime: "static" })
    queryClient.query({ ...query.other.countries, staleTime: "static" })
  },
  head: () => ({
    meta: [
      {
        title: "Settings | Arduino Cloud"
      }
    ]
  })
})
